import React, { memo } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useIntl } from 'react-intl'
import usePageProps from 'hooks/usePageProps'
import sx from './styles'

const PostCard = ({
  item,
  handleClick,
  sx: sxProp,
}) => {
  const { formatMessage: f } = useIntl()
  const href = f({ id: 'BLOG_DETAIL_ROUTE' }, { slug: item?.slug })
  const { locale } = usePageProps()

  return (
    <Link
      href={href}
      passHref
      sx={{ ...sx.root, ...sxProp }}
    >
      <Paper
        sx={sx.root}
        elevation={0}
        component="a"
        onClick={handleClick}
        title={locale === 'es' ? item?.name_es : item?.name_en}
      >
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
          >
            <Box sx={sx.image}>
              <Image
                src={item?.featured_image}
                alt={item?.title}
                layout="responsive"
                width={250}
                height={160}
                objectFit="cover"
                blurDataURL={item?.featured_image}
                placeholder="blur"
                unoptimized
              />
            </Box>

            {item?.state && (
              <Box
                mt={1}
              >
                <Typography
                  variant="small"
                  sx={sx.categoryTitle}
                >
                  {item?.state_name}
                </Typography>

              </Box>
            )}

            <Box mt={1}>
              <Typography
                variant="body1"
                sx={sx.title}
              >
                {locale === 'es' ? item?.name_es : item?.name_en}
              </Typography>
            </Box>
            <Box mt={1}>
              <Typography
                variant="body2"
              >
                {locale === 'es' ? item?.short_description_en : item?.short_description_es}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Link>

  )
}

export default memo(PostCard)
